import React from 'react';
import BannerOdd from './BannerOdd';

function BannerOddsOverlay(props) {
    const bet = props.banner.avvData.bet;
    const desc = props.banner.avvData.desc;
    return (
        <div className="banner-overlay">
            <div className="banner-overlay-text-container">
                <span className="banner-overlay-title">{desc}</span>
                <span className="banner-overlay-desc">{props.banner.text}</span>
            </div>
            <div className="banner-odds-container">
                {bet.odds.map(odd =>
                    <BannerOdd key={odd.id} {...odd} />
                )}
            </div>
        </div>
    );
}

export default BannerOddsOverlay;